import makeService from './api';

export default makeService('notification_types');
